// Module
var code = "<div> <div class=\"conditions-list\"></div> <div class=\"addCondition\"> <a>Add condition</a> </div> </div> ";
// Exports
export default code;